import React, { createContext, useContext, useState, useCallback } from 'react';

const NavigationLockContext = createContext({
  isNavigationLocked: false,
  lockMessage: '',
  setNavigationLock: () => {},
});

export const NavigationLockProvider = ({ children }) => {
  const [isNavigationLocked, setIsNavigationLocked] = useState(false);
  const [lockMessage, setLockMessage] = useState('');

  const setNavigationLock = useCallback((locked, message = '') => {
    setIsNavigationLocked(locked);
    setLockMessage(message);
  }, []);

  return (
    <NavigationLockContext.Provider value={{ isNavigationLocked, lockMessage, setNavigationLock }}>
      {children}
    </NavigationLockContext.Provider>
  );
};

export const useNavigationLock = () => useContext(NavigationLockContext);

export default NavigationLockContext;
